"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
function Pagination(_a) {
    var entity = _a.entity, onPageChange = _a.onPageChange;
    if (!entity || !entity.current_page || entity.last_page === 1) {
        return null;
    }
    // TODO question to Sven, why is this a stack?
    return ((0, jsx_runtime_1.jsx)(material_1.Stack, { children: (0, jsx_runtime_1.jsx)(material_1.Pagination, { sx: {
                marginTop: '12px',
                marginBottom: '12px',
                '& ul': {
                    justifyContent: 'space-around',
                    flexWrap: 'nowrap',
                },
            }, size: "medium", color: "primary", count: entity.last_page, page: entity.current_page, onChange: function (event, page) {
                if (onPageChange) {
                    onPageChange(page);
                }
            } }) }));
}
exports.default = Pagination;
